export const parseJSON = (data, def = {}) => {
  if (!data) return def;
  try {
    const parsed = JSON.parse(data);
    return typeof parsed === "string" ? JSON.parse(parsed) : parsed;
  } catch {
    return def;
  }
};

export const wrapWithSerial = (data, serials) => {
  if (
    serials.length <= 1 &&
    Object.keys(data).length > 0 &&
    !data.hasOwnProperty(serials[0]?.serial)
  ) {
    return { [serials[0]?.serial]: data };
  }
  return data;
};
